import { TIPTAP_CAPTION_TYPE, TIPTAP_FIGURE_TYPE } from "./../../ricos-content/index.js";
import { createRicosNodeExtension } from "./../../plugin-commons/index.js";
import { Caption } from "./caption.js";
const captionTiptapExtension = createRicosNodeExtension({
  type: "react-node",
  groups: ["not-overtypable", "custom-styles"],
  name: TIPTAP_CAPTION_TYPE,
  Component: Caption,
  placeholder: {
    predicate: ({ doc, pos, selection }) => {
      const $pos = doc.resolve(pos);
      const parentNode = $pos.parent;
      if (parentNode.type.name !== TIPTAP_FIGURE_TYPE) {
        return false;
      }
      const isCurrNodeSelected = selection.from <= pos && selection.to >= pos;
      const isCaptionFocused = selection.from === selection.to;
      return isCurrNodeSelected && !isCaptionFocused;
    },
    content: "Figure_Caption_Input_Placeholder",
    alwaysVisible: true,
    alignCenter: true
  },
  createExtensionConfig() {
    return {
      name: this.name,
      group: "figureSecondChildContent",
      content: "text*",
      isolating: true,
      draggable: false,
      selectable: true,
      addAttributes() {
        return {
          textStyle: {
            default: {
              textAlignment: "CENTER",
              lineHeight: 1.5
            }
          },
          // Using `styleDefaults` instead of a `style` object because
          // Tiptap requires the default value of `style` to be a string.
          // For more context, see:
          // https://github.com/ueberdosis/tiptap/blob/v2.8.0/packages/core/src/utilities/mergeAttributes.ts#L26
          styleDefaults: {
            default: {
              paddingTop: "16px",
              paddingBottom: "16px"
            }
          }
        };
      },
      parseHTML() {
        return [
          {
            tag: "figcaption"
          }
        ];
      },
      renderHTML() {
        return ["figcaption", {}, 0];
      }
    };
  }
});
export {
  captionTiptapExtension
};
//# sourceMappingURL=caption-tiptap-extension.js.map
